import { useRouter } from 'next/router'

export const useBrandedPage = () => {
  const { asPath } = useRouter()
  const pathname = asPath.split('?')[0].split('#')[0].replace(/\/$/, '') || '/'

  const isBrandedPage =
    [
      '/',
      '/how-it-works',
      '/who-we-help',
      '/why-were-better',
      '/facts',
      '/testimonials',
      '/faq',
      '/about',
      '/scam',
    ].includes(pathname) || pathname.startsWith('/experiment/')

  return { isBrandedPage, pathname }
}
